import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  hotspotStyle: {
    background:
      "linear-gradient(\n    to right,\n    #29323c,\n    #485563\n  )",
    hotspotColor: "linear-gradient(to right, #363795, #005C97)",
    hotspotTextColor: "#fff",
    hotspotLabelBgColor: "rgba(0, 0, 0, 0.67)",
    hotspotLabelTextColor: "#fff",
    hotspotLabelBlur: "saturate(180%) blur(20px)",
  },
};

export const CustomizerSlice = createSlice({
  name: "customizer",
  initialState,
  reducers: {
    setHotspotStyle: (state, action) =>
      void (state.hotspotStyle = action.payload),
  },
});

export const { setHotspotStyle } = CustomizerSlice.actions;
export default CustomizerSlice.reducer;
